/**
 * Generic currency formatting tool using Intl.NumberFormat
 */
export const formatCurrency = (
  value: number | string,
  currency: string = "CHF",
  locale: string = "fr-CH",
) => {
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return value;

  // For Swiss French (fr-CH), Intl.NumberFormat typically uses 'CHF 1 200.00'
  // But often for marketing, we want to control the exact format.
  // The user previously used: currency + " " + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    // Some locales put the currency symbol at the end or use spaces differently.
    // Intl handles this automatically according to the locale.
  }).format(num);
};

/**
 * Basic number formatting with thousands separator
 */
export const formatNumber = (
  value: number | string,
  locale: string = "fr-CH",
) => {
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return value;

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
};
